import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DacDealerDTO } from "@shared/model/dealerAdminDTO";
import { AdminService } from "@shared/services/admin/admin.service";

@Component({
	selector: "app-dealer-dac-dialog",
	templateUrl: "./dealer-dac-dialog.component.html",
	styleUrl: "./dealer-dac-dialog.component.scss",
	standalone: false
})
export class DealerDacDialogComponent implements OnInit {
	displayedColumns: string[] = ["sincom", "businessName", "address", "city", "configure"];
	dealersTable = new MatTableDataSource<DacDealerDTO>();

	private paginator: MatPaginator;
	private sort: MatSort;

	@ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	@ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	constructor(
		@Inject(MAT_DIALOG_DATA) public vatCode: string,
		private adminService: AdminService,
		public dialogRef: MatDialogRef<DealerDacDialogComponent>
	) { }

	ngOnInit() {
		this.adminService.getDealerDacUsingGET(this.vatCode)
			.subscribe(value => {
				this.dealersTable.data = value;
			});
	}

	setDataSourceAttributes() {
		this.dealersTable.sort = this.sort;
		this.dealersTable.paginator = this.paginator;
	}

	applyFilter(filterValue: string) {
		this.dealersTable.filter = filterValue.trim().toLowerCase();
	}

	select(element: any) {
		this.dialogRef.close(element);
	}
}